import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const { data: { session }, error } = await supabase.auth.getSession();

      if (error || !session) {
        toast.error('Sign-in failed. Please try again.');
        navigate('/login', { replace: true });
        return;
      }

      navigate('/app', { replace: true });
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-primary animate-pulse">YELV</h1>
        <p className="mt-2 text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
